import { useState } from "react";
import { Menu, X } from "lucide-react";
import { TabsList } from "@/components/ui/tabs";

const item = "[&>button]:w-full [&>button]:justify-start [&>button]:px-3 [&>button]:py-2.5 [&>button]:rounded-lg [&>button]:text-sm [&>button]:font-medium [&>button]:text-slate-600 [&>button:hover]:bg-slate-100 [&>button[data-state=active]]:bg-blue-50 [&>button[data-state=active]]:text-blue-700 [&>button[data-state=active]]:shadow-none";

export const SideMenuButton = ({ open, setOpen, label = "Menu" }) => (
  <button onClick={() => setOpen(!open)} className="lg:hidden mb-4 inline-flex items-center gap-2 bg-white border border-slate-200 text-slate-700 font-semibold text-sm px-4 py-2 rounded-lg shadow-sm" data-testid="side-menu-toggle">
    {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}{label}
  </button>
);

export const SidePanel = ({ open, setOpen, children, testId = "side-menu" }) => (
  <>
    {open && <div className="lg:hidden fixed inset-0 bg-slate-900/40 z-[55]" onClick={() => setOpen(false)} data-testid={`${testId}-backdrop`} />}
    <aside className={`fixed lg:sticky top-0 lg:top-20 left-0 z-[60] lg:z-auto h-full lg:h-auto w-64 lg:w-56 shrink-0 bg-white lg:bg-transparent border-r lg:border-0 border-slate-200 p-4 lg:p-0 pt-20 lg:pt-0 overflow-y-auto lg:max-h-[calc(100vh-6rem)] transition-transform duration-200 ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`} data-testid={testId}>
      {children}
    </aside>
  </>
);

/* Vertical tab menu: sidebar on desktop, slide-out on phones. Must be rendered inside <Tabs>. */
export const SideTabs = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <SideMenuButton open={open} setOpen={setOpen} />
      <SidePanel open={open} setOpen={setOpen}>
        <TabsList onClick={(e) => e.target.closest("button") && setOpen(false)} className={`flex flex-col items-stretch h-auto w-full bg-white border border-slate-200 rounded-xl p-2 gap-0.5 shadow-sm ${item}`}>
          {children}
        </TabsList>
      </SidePanel>
    </>
  );
};
